const translations = {
    applicationSite: 'Application site',
    customer: 'Customer',
    customerAddress: 'Customer address',
    customerName: 'Customer name',
    phone: 'Phone'
};

export default translations;
